module.exports = __webpack_public_path__ + "images/howitworks-step2.3d7ad9ae4a67f5548eeb06329a70cc71.svg";